import { RealtimeStatsApiClient } from '@fourthwall/services/dist/RealtimeStatsApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useActiveVisitorsQuery = createQueryHook(RealtimeStatsApiClient.getActiveUsers, {
  queryKey: ['activeVisitors'],
})
